import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { BACKEND_URL } from '../app.config';
import { ListResult } from '../api/data-model';
import { TaskTemplate, TaskTemplateAttachment } from '../api/task-template';

/** Upload endpoint returns BlobFileInfo (filePath), mapped to template attachment. */
interface BlobFileInfoResponse {
  fileName?: string;
  filePath?: string;
  fileSize?: number;
  mimeType?: string;
  mIMEType?: string;
}

@Injectable({
  providedIn: 'root',
})
export class TaskTemplateService {
  constructor(
    private readonly http: HttpClient,
    @Inject(BACKEND_URL) private readonly baseUrl: string,
  ) {}

  getList(sorting: string, skipCount: number, maxResultCount: number): Observable<ListResult<TaskTemplate>> {
    return this.http.get<ListResult<TaskTemplate>>(`${this.baseUrl}/api/app/task-template`, {
      params: {
        sorting,
        skipCount,
        maxResultCount,
      },
    });
  }

  getTaskTemplate(id: string): Observable<TaskTemplate> {
    return this.http.get<TaskTemplate>(`${this.baseUrl}/api/app/task-template/${id}`);
  }

  addTaskTemplate(taskTemplate: TaskTemplate): Observable<TaskTemplate> {
    return this.http.post<TaskTemplate>(`${this.baseUrl}/api/app/task-template`, taskTemplate);
  }

  updateTaskTemplate(id: string, taskTemplate: TaskTemplate): Observable<TaskTemplate> {
    return this.http.put<TaskTemplate>(`${this.baseUrl}/api/app/task-template/${id}`, taskTemplate);
  }

  uploadTaskAttachment(file: File, taskTemplateId: string): Observable<TaskTemplateAttachment> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('taskTemplateId', taskTemplateId);
    return this.http
      .post<BlobFileInfoResponse>(`${this.baseUrl}/api/app/task-template/upload-attachment`, formData)
      .pipe(
        map((uploaded) => ({
          fileName: uploaded.fileName ?? file.name,
          sharePointFilePath: uploaded.filePath,
          fileSize: uploaded.fileSize ?? file.size,
          mimeType: uploaded.mimeType ?? uploaded.mIMEType ?? file.type,
        })),
      );
  }
}
